import React from 'react';
import { Segment, Loader } from 'semantic-ui-react';

type Props = {
  height?: string | number;
};

export const SegmentLoader = ({ height = 100 }: Props) => {
  return (
    <Segment>
      <div style={{ height }}>
        <Loader active />
      </div>
    </Segment>
  );
};
